import React from 'react';
import { useAuth } from '../context/AuthContext';
import TrocarSenha from '../components/TrocarSenha';

export default function PasswordChangeGate({ children }) {
  const { isLogado, userData } = useAuth();
  if (isLogado && userData.troca_senha_obrigatoria) return <TrocarSenha />;
  return children;
}
